import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="bg-white shadow-sm sticky top-0 z-50" data-id="element-245">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
        <div className="flex justify-between h-16" data-id="element-247">
          <div className="flex items-center" data-id="element-248">
            <BookOpenIcon className="h-8 w-8 text-blue-600" data-id="element-249" />
            <span className="ml-2 text-xl font-semibold text-gray-900" data-id="element-250">
              Young Mind
            </span>
          </div>
          <div className="flex items-center" data-id="element-251">
            <a href="#buy-now" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-252">
              Get Your Copy
            </a>
          </div>
        </div>
      </div>
    </nav>;
}